import { isEmpty } from 'lodash';
import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_CREATE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import InventoryCreateInitialSelectors from './InventoryCreateInitialSelectors';

const getCreateInitialInventoryModalActions = (props) => {
  const {
    selectedStores,
    selectedSupplierProducts,
    shouldRestrictSupplierProducts,
    selectedStoreILT,
    selectedDate,
    handleCreateInitialInventory,
    resetCreateInitialInventoryModal,
  } = props;

  const isMissingRequiredSupplierProducts =
    shouldRestrictSupplierProducts && selectedSupplierProducts.length === 0;

  const isActionDisabled =
    isMissingRequiredSupplierProducts ||
    isEmpty(selectedStores) ||
    !selectedDate ||
    !selectedStoreILT;

  const selectedStoresIds = selectedStores.map(({ id }) => id);
  const selectedSupplierProductIds = selectedSupplierProducts.map(({ id }) => id);

  return [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_CREATE_BUTTON(),
      handleClick: () => {
        handleCreateInitialInventory(
          selectedStoresIds,
          selectedDate,
          selectedStoreILT,
          shouldRestrictSupplierProducts ? selectedSupplierProductIds : null,
        );
        resetCreateInitialInventoryModal();
      },
      isDisabled: isActionDisabled,
    },
  ];
};

export const getCreateInitialInventoryModalConfig = (props) => {
  const { resetCreateInitialInventoryModal } = props;
  const params = {
    type: 'action',
    width: '542px',
    height: 'auto',
    icon: '/images/inpulse/add-black-small.svg',
    title: i18next.t('STOCKS.STOCKS.LIST_CREATE_INITIAL_INVENTORY'),
    handleCloseCleanUp: resetCreateInitialInventoryModal,
    actions: getCreateInitialInventoryModalActions(props),
    component: InventoryCreateInitialSelectors,
    data: props,
  };

  return params;
};
